import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainUnBindAccessControlDevice(params) {
  return maintainRequest.post(
    `/device/maintenanceMan/accessDevice/unBindAccessControlDevice`,
    null,
    {
      params,
    }
  );
}
